import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../../src/assets/images/logo.png";
import {
  DeleteOutlined,
  DoubleRightOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {baseUrl} from "../../../../src/config"
export const AdminPanel = () => {
  const [path,setPath]=useState("/admin/enquiries")
   const navigate=useNavigate()
   const location=useLocation()
   console.log({location})
   const storedData = localStorage.getItem("loginData");
const loginData = JSON.parse(storedData);
useEffect(()=>{
setPath(location.pathname)
},[location.pathname])
  const handleLogout = async () => {
    // handle logout functionality here, e.g., clearing session or tokens
    try {
      const resp = await axios.post(
        `${baseUrl}account/${loginData.id}/logout`,{
          username:loginData?.username,
          authToken:loginData.authToken
        },{
            headers:{
                Authorization:`Bearer ${loginData.authToken}`
            }
        }
      );
      if(resp){
        message.success("Logged out successfully")
        navigate("/admin/login")
        localStorage.setItem("loginData","{}")
      }
    
    } catch (e) {
      console.error(e);
      message.error("Failed to logout")
    }
    console.log("Logged out");
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Left Navigation */}
      <div
        style={{
          width: "100px",
          background: "#f4f4f4",
          padding: "20px",
          borderRight: "1px solid #ddd",
          display:"flex",
          justifyContent:"space-between",
          flexDirection:"column"

        }}
      >
       <div>
        <div style={{fontWeight:600,marginBottom:30}}>GEES ADMIN</div>
       
        <ul style={{ listStyleType: "none", padding: 0,display:"flex",flexDirection:"column",gap:50 }}>
          <li>
            <Link style={{color: path === "/admin/enquiries"?"#273975": "black"}}  to="/admin/enquiries">Enquiries <span><DoubleRightOutlined /></span></Link>
          </li>
          <li>
            <Link style={{color: path === "/admin/products"?"#273975": "black"}} to="/admin/products">Products <span><DoubleRightOutlined /></span></Link>
          </li>
          {/* <li>
            { <Link style={{color: path === "/admin/portfolio"?"#273975": "black"}} to="/admin/portfolio">Portfolio <span><DoubleRightOutlined /></span></Link>}
         </li> */}
          <li>
            <Link style={{color: path === "/admin/reviews"?"#273975": "black"}} to="/admin/reviews">Reviews <span><DoubleRightOutlined /></span></Link>
          </li>

          {/* Logout Button in Left Navigation */}
          
        </ul>
       </div>
        <div>
            <button
              onClick={handleLogout}
              style={{
                width: "100%",
                padding: "10px",
                background: "#f44336",
                color: "#000000",
                border: "none",
                cursor: "pointer",
                marginTop: "20px",
              }}
            >
              Logout
            </button>
          </div>
      </div>

      {/* Main content area */}
      <div style={{ flex: 1, padding: "20px" }}>
        <Outlet /> {/* This will render the corresponding component based on the route */}
      </div>
    </div>
  );
};
